import { Helmet } from "react-helmet-async";
import { AppProviders } from "contexts";
import { GlobalErrorBoundary } from "features/misc";
import { StagingSignIn, useStagingSignIn } from "features/stagingSignIn";
import { Router } from "./Router";

function App() {
  const { showStagingSignIn, ...props } = useStagingSignIn();

  return (
    <GlobalErrorBoundary>
      <AppProviders>
        <Helmet defaultTitle="HUG | Community for digital artists and art lovers" />
        {showStagingSignIn ? <StagingSignIn {...props} /> : <Router />}
      </AppProviders>
    </GlobalErrorBoundary>
  );
}

export { App };
